import NorthEastIcon from '@mui/icons-material/NorthEast';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import type { UIMessage } from 'ai';
import { useNavigate } from 'react-router-dom';

type ActionVariant = 'navigate' | 'query';

type RecommendedAction = {
  label: string;
  href?: string;
  query?: string;
  variant?: ActionVariant;
};

type Props = {
  message: UIMessage;
  onActionQuery?: (text: string) => void;
};

export function RecommendedActionsPanel({ message, onActionQuery }: Props) {
  const navigate = useNavigate();

  const meta = message.metadata as { recommendedActions?: RecommendedAction[] } | undefined;
  const actions = meta?.recommendedActions;
  if (!actions?.length) return null;

  const handleClick = (action: RecommendedAction) => {
    if (action.href) {
      navigate(action.href);
    } else if (action.query) {
      onActionQuery?.(action.query);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontSize: 12,
          fontWeight: 600,
          lineHeight: '16px',
          letterSpacing: 0,
          color: '#7e8796',
          mb: 1,
        }}
      >
        Suggested follow-ups
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {actions.map((action) => (
          <ButtonBase
            key={action.label}
            onClick={() => handleClick(action)}
            data-vy="ai-copilot-recommended-action"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1.5,
              borderRadius: '10px',
              bgcolor: '#e8f0fe',
              textAlign: 'left',
              width: '100%',
              transition: 'background-color 0.15s',
              '&:hover': { bgcolor: '#d4e4fd' },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: 13,
                fontWeight: 400,
                color: '#01060d',
                lineHeight: 1.4,
              }}
            >
              {action.label}
            </Typography>
            <NorthEastIcon sx={{ fontSize: 16, color: '#305DFF', flexShrink: 0, ml: 1 }} />
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
}
